import styled from '@app/styled';
import { color, font, transition } from '@app/theme';

import { ModalSize } from './types';

export const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4050;
    overflow: auto;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    outline: 0;
    padding: 0 10px;
`;

interface InnerProps {
    size: ModalSize;
}

export const Inner = styled.div<InnerProps>`
    position: relative;
    max-width: ${(props) => (props.size === ModalSize.small ? '300px' : '600px')};
    margin: 30px auto;
    background-color: ${color('custom.background.primary')};
    border-radius: 5px;
    padding: 27px 30px;
    font-size: 14px;
    line-height: 20px;
`;

export const Header = styled.div`
    min-height: 44px;
    padding: 0 0 23px;
    font-weight: 500;
    font-family: ${font('family.heading')};
    font-size: 21px;
    line-height: 21px;
    color: ${color('custom.content.primary')};
`;

export const CloseButton = styled.button`
    margin-top: -4px;
    -webkit-appearance: none;
    padding: 0;
    cursor: pointer;
    background: transparent;
    border: 0;
    float: right;
    font-size: 27px;
    line-height: 1;
    color: ${color('custom.interactive.content.idle')};
    transition: color ${transition('default')};
    fill: currentColor;

    &:hover {
        color: ${color('custom.interactive.content.hover')};
    }

    &:active {
        color: ${color('custom.interactive.content.pressed')};
    }
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: row-reverse;
    padding: 23px 0 0;

    button + button {
        margin-right: 10px;
    }
`;

export const Backdrop = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4040;
    background-color: #000;
    opacity: 0.5;
`;
